import "../styles/header.css";
function HeaderPanel() {
    return (
      <div className="HeaderPanel">
        <div className="iconContainer"><a href="/" className="iconLink"> </a></div>
        <div className="menusList">
        <div className="menuPad">
          <div className="menuitems">
          <div className="menuItem">Home</div>
          <div className="menuItem">Information</div>
          <div className="menuItem">Community</div>
          <div className="menuItem">Services & Apps</div>
          <div className="menuItem">Data</div>
          <div className="menuItem">About Us</div>
          {/* <button>Log In</button> */} 
          </div>
        </div>
      </div>
      </div>
    );
}

export default HeaderPanel;